import { type FC, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { useMediaQuery } from 'usehooks-ts'

import { Dialog, DialogContent, type DialogProps, DialogTitle } from 'base-ui'
import screens from 'tailwind-preset/screens.js'

import { ProductSearchRefinements } from '../ProductSearchRefinements'
import { ProductSearchRefinementSortingChipButtonList } from '../ProductSearchRefinementSortingChipButtonList'
import { ProductSearchRefinementStateProvider } from '../ProductSearchRefinementStateContext'

import { ProductSearchRefinementsDialogButtons } from './ProductSearchRefinementsDialogButtons'

import styles from './ProductSearchRefinementsDialog.module.css'

export const ProductSearchRefinementsDialog: FC<
  Pick<DialogProps, 'onClose' | 'open'>
> = ({ onClose, open }) => {
  const matches = useMediaQuery(`(min-width: ${screens.desktop})`, {
    defaultValue: false,
    initializeWithValue: false,
  })

  useEffect(() => {
    /**
     * Close the dialog when the screen size changes to desktop and the dialog is open.
     */
    if (open && matches) {
      onClose?.({}, 'backdropClick')
    }
  }, [matches, onClose, open])

  return (
    <Dialog
      onClose={onClose}
      open={open}
      slotProps={{
        dialog: {
          className: styles['product-search-refinements-dialog'],
        },
      }}
    >
      <DialogTitle onClose={onClose}>
        <FormattedMessage id="general.label.selectFilter" />
      </DialogTitle>
      <DialogContent
        className="flex flex-1 flex-col gap-6 bg-light-primary-low p-0"
        data-qa-id="product-filter-variant"
      >
        <ProductSearchRefinementStateProvider isMobile>
          <ProductSearchRefinementSortingChipButtonList />
          <div
            className="flex flex-col gap-6 p-4"
            data-qa-id="product-filter-variant-refinements"
          >
            <ProductSearchRefinements />
          </div>
        </ProductSearchRefinementStateProvider>
        <ProductSearchRefinementsDialogButtons onClose={onClose} />
      </DialogContent>
    </Dialog>
  )
}
